import { rem } from "@mantine/core";
import React from "react";

interface IconScrollToTopProps extends React.ComponentPropsWithoutRef<"svg"> {
  size?: number | string;
}

export const IconScrollToTop = ({
  size,
  style,
  ...others
}: IconScrollToTopProps) => {
  return (
    <svg
      width="44"
      height="47"
      viewBox="0 0 44 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: rem(size), height: rem(size), ...style }}
      {...others}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M38.3222 27.6893L21.9885 11.3556L5.67779 27.6663L0 21.9885L21.9885 0L44 22.0115L38.3222 27.6893ZM5.67779 46.5462L0 40.8684L21.9885 18.8799L44 40.8856L38.3222 46.5634L21.9885 30.2297L5.67779 46.5462Z"
        fill="white"
      />
    </svg>
  );
};
